module.exports = __webpack_public_path__ + "26fbfe21c3d684f19cade9f6ced04143.svg";